<template>
  <div>
    <am-card-header @click="toggle" class="am-accordion-item-header">
      <!-- @slot title -->
      <slot name="title" />
      <am-icon-button slot="actions" :icon="isOpen ? 'close' : 'expand_more'" />
    </am-card-header>
    <am-card-body :class="{ 'am-accordion-item--closed': !isOpen }">
      <!-- @slot content -->
      <slot name="content" />
    </am-card-body>
    <am-divider />
  </div>
</template>

<script>
import { AmIconButton } from "../IconButton";
import { AmCardHeader, AmCardBody } from "../Card";
import { AmDivider } from "../Divider";

export default {
  components: {
    AmIconButton,
    AmDivider,
    AmCardHeader,
    AmCardBody
  },
  data() {
    return { isOpen: false };
  },
  methods: {
    toggle() {
      this.$parent.$emit("toggle", this.$el);
    }
  }
};
</script>
